"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SelectionPanelProps_1 = require("../../SelectionPanelProps");
var Carousel_1 = require("../../../../containers/Carousel");
var utils_1 = require("../../../../../utils/utils");
var SELECT_PLAN = 'Select Plan';
var mockCards = [
    {
        background: '',
        ctaText: SELECT_PLAN,
        id: 1,
        price: 35,
        subtitle: 'Live a little',
        title: '60+ channels',
    },
    {
        background: '',
        ctaText: SELECT_PLAN,
        id: 2,
        price: 50,
        subtitle: 'Just right',
        title: '80+ channels',
    },
    {
        background: '',
        ctaText: SELECT_PLAN,
        id: 3,
        price: 60,
        subtitle: 'Go big',
        title: '100+ channels',
    },
    {
        background: '',
        ctaText: SELECT_PLAN,
        id: 4,
        price: 70,
        subtitle: 'Gotta have it',
        title: '120+ channels',
    },
];
var mockMultiCards = [
    {
        background: '',
        ctaText: 'Add Plan',
        id: 5,
        price: 5,
        subtitle: '',
        title: 'HBO',
    },
    {
        background: '',
        ctaText: 'Add Plan',
        id: 6,
        price: 5,
        subtitle: '',
        title: 'Cinemax',
    },
    {
        background: '',
        ctaText: 'Add Plan',
        id: 7,
        price: 5,
        subtitle: '',
        title: 'STARZ',
    },
    {
        background: '',
        ctaText: 'Add Plan',
        id: 8,
        price: 45,
        subtitle: '',
        title: 'NFL',
    },
];
var DemoCardsContainer = /** @class */ (function (_super) {
    __extends(DemoCardsContainer, _super);
    function DemoCardsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoCardsContainer.prototype.render = function () {
        var _this = this;
        var data = {
            background: 'images/DtvCardBlacklist.jpg',
        };
        var _a = this.props.options.cardSizes, width = _a.width, height = _a.height;
        var style = {
            border: '1px solid black',
            display: 'inline-block',
            height: height + "px",
            maring: '1px',
            width: width + "px",
        };
        var cardsArr = this.props.options.type === 'SINGLE' ? mockCards : mockMultiCards;
        var cards = cardsArr.map(function (card) {
            var onClick = _this.props.events.onSelect.bind(_this, card);
            return (React.createElement("div", { style: style, key: card.id },
                React.createElement("h3", null, card.title),
                React.createElement("p", null, card.subtitle),
                React.createElement("button", { onClick: onClick }, card.ctaText)));
        });
        return (React.createElement("div", { style: { overflow: 'auto' } },
            React.createElement(Carousel_1.default, { testId: utils_1.default(this.props.testId, 'Carousel') }, cards)));
    };
    DemoCardsContainer.defaultProps = {
        options: {
            className: '',
            type: SelectionPanelProps_1.SelectionPanelType.SINGLE,
        },
    };
    return DemoCardsContainer;
}(React.Component));
exports.default = DemoCardsContainer;
//# sourceMappingURL=DemoCardsContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectionPanel/components/DemoCardsContainer/DemoCardsContainer.js
// module id = 1412
// module chunks = 8